import ArrowIco from "../../../../assets/careerBuddy/arrow_ic.svg";
import "./style.scss";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initCompanions, initGetProfile } from "../../../../redux/actions";
import { isAccessFeature } from "../../../../common/utils";

export default function AiCompanions() {
  const router = useNavigate();
  const dispatch = useDispatch();
  const { aiAgents } = useSelector((state) => state.aiCompanionsReducer);
  const hitOnetime = useRef(false);
  const { user } = useOutletContext();
  const isErrorPricing = isAccessFeature(user)

  const handleRouteDetail = (res) => {
    router(
      `/profile/ai-companions/${res.id}/${res.name
        .toLowerCase()
        .replaceAll(" ", "-")}`,
    );
  };
  useEffect(() => {
    if (!hitOnetime.current) {
      dispatch(initCompanions({ page: 1, per_page: 50 }));
      hitOnetime.current = true;
    }
  }, [dispatch]);

  const transformArray = (arr) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += 4) {
      const group = arr.slice(i, i + 4);
      const top = group.filter((_, idx) => idx % 2 === 0);
      const bottom = group.filter((_, idx) => idx % 2 === 1);
      chunks.push({ top, bottom });
    }
    return chunks;
  };
  useEffect(()=>{
    dispatch(initGetProfile())
  },[])
  const agentChunks = transformArray(
    [...aiAgents.results, { name: "More Coming Soon!", key: "moor_soon" }] ||
      [],
  );
  return (
    <div className="aiCompanions__container">
      <div className="aiCompanions__backScoop">
        <button onClick={() => router(-1)}>
          <img src={ArrowIco} alt="back" /> Back
        </button>
        {/* <div className="aiCompanions__backScoop-scoops">
                <p>Your scoops: <span>2345</span></p>
                <img src={CoinScoopsIco} />
            </div> */}
      </div>
      <div className="aiCompanions__title">
        <h3>AI Companions</h3>
        <p>Your Personal AI Coaches for the Future You Want!</p>
      </div>
      {aiAgents.results?.length > 0 && isErrorPricing.plan_active? (
        <div className="aiCompanions__buddylist__row">
          {agentChunks.map((chunk, chunkIndex) => (
            <ul key={chunkIndex} className={`aiCompanions__buddylist`}>
              {chunk.top.map((res, index) => (
                <li key={index}>
                  {res?.key === "moor_soon" ? (
                    <MoreSoonNew />
                  ) : (
                    <div className="animateDiv">
                      <div className="aiCompanions__buddylist__list">
                        <button
                          className="aiCompanions__buddylist__info"
                          onClick={() => handleRouteDetail(res)}
                        >
                          {res.image && (
                            <img src={res.image} alt="ico" height={74} />
                          )}
                          <h5>{res.name}</h5>
                        </button>
                      </div>
                      <div className="aiCompanions__buddylist__list card-back">
                        <button
                          className="aiCompanions__buddylist__info"
                          onClick={() => handleRouteDetail(res)}
                        >
                          <p>{res.short_description || res.name}</p>
                        </button>
                      </div>
                    </div>
                  )}
                </li>
              ))}
              {chunk.top?.length === 1 ? <li></li> : null}
              {chunk.bottom.map((res, index) => (
                <li key={index}>
                  {res?.key === "moor_soon" ? (
                    <MoreSoonNew />
                  ) : (
                    <div className="animateDiv">
                      <div className="aiCompanions__buddylist__list">
                        <button
                          className="aiCompanions__buddylist__info"
                          onClick={() => handleRouteDetail(res)}
                        >
                          {res.image && (
                            <img src={res.image} alt="ico" height={74} />
                          )}
                          <h5>{res.name}</h5>
                        </button>
                      </div>
                      <div className="aiCompanions__buddylist__list card-back">
                        <button
                          className="aiCompanions__buddylist__info"
                          onClick={() => handleRouteDetail(res)}
                        >
                          <p>{res.short_description || res.name}</p>
                        </button>
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          ))}
        </div>
      ) : (
        <div className="emptySessionHistotyCont">
          <div className="emptySessionHistotyCont__emptArea">
            <p className="emptySessionHistotyCont__emptArea__text">
              You don’t have any assigned yet
            </p>
          </div>
        </div>
      )}

      {/* {aiAgents.results?.length > 0 ? (
        <div className="aiCompanions__buddylist__row">
          <ul className="aiCompanions__buddylist">
            {aiAgents.results?.map((res, index) => (
              <li key={index}>
                <div className="animateDiv">
                  <div className="aiCompanions__buddylist__list">
                    <button
                      className="aiCompanions__buddylist__info"
                      onClick={() => handleRouteDetail(res)}
                    >
                      {res.image && (
                        <img src={res.image} alt="ico" height={74} />
                      )}
                      <h5>{res.name}</h5>
                    </button>
                  </div>
                  <div className="aiCompanions__buddylist__list card-back">
                    <button
                      className="aiCompanions__buddylist__info"
                      onClick={() => handleRouteDetail(res)}
                    >
                      <p>{res.short_description || res.name}</p>
                    </button>
                  </div>
                </div>
              </li>
            ))}
            {aiAgents.results?.length === 1 ? <MoreSoon /> : null}
          </ul>
          {aiAgents.results?.length > 1 ? <MoreSoon /> : null}
        </div>
      ) : (
        <div className="emptySessionHistotyCont">
          <div className="emptySessionHistotyCont__emptArea">
            <p className="emptySessionHistotyCont__emptArea__text">
              You don’t have any assigned yet
            </p>
          </div>
        </div>
      )} */}
    </div>
  );
}
const MoreSoonNew = () => {
  return (
    <div className="aiCompanions__buddylist__li w-auto">
      <div className="aiCompanions__buddylist__list w-auto">
        <button className="aiCompanions__buddylist__info grey">
          <h5>More Coming Soon!</h5>
        </button>
      </div>
    </div>
  );
};
